<div id="{{ id_dialog }}"
     class="fiko-floating-toolbar-modal {{ ozelSinif }}"
     [style.width]="genislik"
     [style.height]="minimize ? 'auto' : yukseklik"
     [style.z-index]="zIndex"
     [style.display]="gorunur ? 'block' : 'none'"
     [class.minimized]="minimize"
     (mousedown)="oneGetir()">

    <!-- Toolbar Container -->
    <div class="fiko-toolbar-container" #toolbarContainer>

        <!-- Draggable Handle + Header -->
        @if (baslikGorunur) {
        <div class="fiko-toolbar-header">

            <!-- Draggable Handle (Sol taraf - grip icon) -->
            @if (handleGorunur) {
            <div class="toolbar-handle" title="Taşımak için sürükle">
                <div class="handle-grip">
                    <div class="grip-line"></div>
                    <div class="grip-line"></div>
                    <div class="grip-line"></div>
                </div>
            </div>
            }

            <!-- Başlık Alanı -->
            <div class="toolbar-baslik">
                <!-- Simge -->
                @if (simge) {
                <span class="toolbar-simge">
                    @switch (simgeTipi) {
                    @case ('url') {
                    <img [src]="simge" class="simge-resim">
                    }
                    @case ('emoji') {
                    <span class="simge-emoji">{{simge}}</span>
                    }
                    @case ('icon') {
                    <i class="icon {{simge}}"></i>
                    }
                    }
                </span>
                }

                <!-- Başlık Text -->
                <span class="baslik-text">{{baslik}}</span>
            </div>

            <!-- Kontrol Butonları (Minimize, Close) -->
            <div class="toolbar-controls">
                <!-- Minimize Button -->
                @if (minimizeButonuGorunur) {
                <button class="toolbar-control-btn minimize-btn"
                        (click)="toggleMinimize()"
                        [title]="minimize ? 'Genişlet' : 'Küçült'">
                    @if (minimize) {
                    <i class="icon window maximize outline"></i>
                    } @else {
                    <i class="icon window minimize outline"></i>
                    }
                </button>
                }

                <!-- Close Button -->
                @if (kapatButonuGorunur) {
                <button class="toolbar-control-btn close-btn"
                        (click)="kapa()"
                        title="Kapat">
                    <i class="icon close"></i>
                </button>
                }
            </div>
        </div>
        }

        <!-- Content Area (ng-content slot) -->
        @if (!minimize) {
        <div class="fiko-toolbar-content">
            <!-- 🎯 SLOT - İçerik buraya gelecek -->
            <ng-content></ng-content>
        </div>
        }

    </div>
</div>
